import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { MdHourglassEmpty } from "react-icons/md";
import {
  Header,
  ModuleContainer,
  IconContainer,
  IconStyle,
  ExtentionContainer,
  RefreshDeleteContainer,
} from "./styles";
import { CircularProgress } from "@material-ui/core";
import DelayedFlowIterable from "./DelayedFlowIterable";
import { DateTime } from "luxon";
import {
  CustomRefreshIcon,
  CustomRemoveIcon,
  CustomAddIcon,
} from "../../styles";
import { useDispatch, useSelector } from "react-redux";
import { fetchDashboardFlows } from "../../../../../state/dashboard/actions";

const LoadingIndicator = () => (
  <div
    style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
  >
    <CircularProgress />
  </div>
);

function calculateDelay(estimatedAt, criticalDate) {
  // Initialize delay values to handle undefined or invalid dates
  let delayHours = Infinity; // Use as a fallback sort value
  let delayMessage = "- -"; // Fallback message for display

  // Parse the dates using Luxon for consistent handling
  const estimatedDate = estimatedAt ? DateTime.fromISO(estimatedAt) : null;
  const criticalDateTime = criticalDate ? DateTime.fromISO(criticalDate) : null;

  // Ensure both dates are valid before proceeding
  if (
    estimatedDate &&
    criticalDateTime &&
    estimatedDate.isValid &&
    criticalDateTime.isValid
  ) {
    // Calculate the difference between the dates
    const diff = estimatedDate.diff(criticalDateTime, ["hours"]).toObject();
    delayHours = diff.hours; // This will be used for sorting

    const hoursDelay = Math.abs(diff.hours);
    const daysDelay = hoursDelay / 24;

    // Construct the delay message based on the duration of the delay
    if (hoursDelay < 24) {
      delayMessage = `${hoursDelay.toFixed(1)} horas`;
    } else {
      delayMessage = `${daysDelay.toFixed(1)} dias`;
    }
  }

  return { delayMessage, delayHours };
}

function sortData(dataArray) {
  const dataWithDelay = dataArray.map((item) => {
    const { delayMessage, delayHours } = calculateDelay(
      item.flowStatus.estimatedAt,
      item.flowStatus.criticalDate
    );
    return {
      ...item,
      delayMessage,
      delayHours,
    };
  });

  // Sort by delayHours, placing undefined or missing dates at the end
  return dataWithDelay.sort((a, b) => b.delayHours - a.delayHours);
}

function formatarData(dataString) {
  // Tentar converter a string ISO para um objeto DateTime no Luxon
  const data = DateTime.fromISO(dataString, { zone: "America/Sao_Paulo" });

  // Verificar se a data é válida
  if (data.isValid) {
    // Formatar a data no padrão brasileiro "dd/MM/yyyy HH:mm"
    return data.toFormat("dd/MM/yyyy 'às' HH:mm");
  } else {
    // Caso a data não seja válida, retornar null
    return null;
  }
}

const FluxosAtrasados = ({
  isExpanded,
  toggleExpand,
  isEditing,
  remove,
  restore,
  isExcluded,
}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const dashFlows = useSelector((state) => state.dashboard.flowsProductivity);
  const [lateFlows, setLateFlows] = useState([]);

  const handleFlowClick = (flowId) => {
    history.push({
      pathname: "/workflow/",
      state: "active",
      search:
        "?" +
        new URLSearchParams({
          flowId: flowId,
        }).toString(),
    });
  };

  useEffect(() => {
    if (dashFlows.status === "succeeded") {
      setLateFlows(dashFlows.data.late);
    }
  }, [dashFlows]);

  if (dashFlows.status !== "succeeded") {
    return (
      <ModuleContainer>
        <Header>
          <IconContainer>
            <MdHourglassEmpty style={IconStyle} />
          </IconContainer>
          <LoadingIndicator />
        </Header>
      </ModuleContainer>
    );
  }

  if (dashFlows.status === "succeeded" && lateFlows.length === 0) {
    return (
      <ModuleContainer>
        <Header>
          <IconContainer>
            <MdHourglassEmpty style={IconStyle} />
          </IconContainer>
          Fluxos Atrasados: 0
          <RefreshDeleteContainer>
            {isEditing ? (
              !isExcluded ? (
                <CustomRemoveIcon
                  onClick={(e) => {
                    e.stopPropagation();
                    remove();
                  }}
                />
              ) : (
                <CustomAddIcon
                  onClick={(e) => {
                    e.stopPropagation();
                    restore();
                  }}
                />
              )
            ) : (
              <CustomRefreshIcon
                onClick={(e) => {
                  e.stopPropagation();
                  dispatch(fetchDashboardFlows());
                }}
              />
            )}
          </RefreshDeleteContainer>
        </Header>
      </ModuleContainer>
    );
  }

  return (
    <ModuleContainer isEditing={isEditing}>
      <Header onClick={toggleExpand}>
        <IconContainer>
          <MdHourglassEmpty style={IconStyle} />
        </IconContainer>
        Fluxos Atrasados: {lateFlows.length}
        <RefreshDeleteContainer>
          {isEditing ? (
            !isExcluded ? (
              <CustomRemoveIcon
                onClick={(e) => {
                  e.stopPropagation();
                  remove();
                }}
              />
            ) : (
              <CustomAddIcon
                onClick={(e) => {
                  e.stopPropagation();
                  restore();
                }}
              />
            )
          ) : (
            <CustomRefreshIcon
              onClick={(e) => {
                e.stopPropagation();
                dispatch(fetchDashboardFlows());
              }}
            />
          )}
        </RefreshDeleteContainer>
      </Header>
      {isExpanded && (
        <ExtentionContainer>
          {sortData(lateFlows).map((item, index) => (
            <DelayedFlowIterable
              onClick={() => handleFlowClick(item._id)}
              key={index + Math.random()}
              title={item.title}
              description={item.description}
              client={item.client}
              flowDelta={item.delayMessage}
              LastUpdate={formatarData(item.lastUpdate)}
              //startDate={item.createdAt}
            />
          ))}
        </ExtentionContainer>
      )}
    </ModuleContainer>
  );
};
export default FluxosAtrasados;
